export default "__VITE_ASSET__BR7PXvk1__"